import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4themes_material from "@amcharts/amcharts4/themes/material";
import am4themes_dark from "@amcharts/amcharts4/themes/dark";
import { useLayoutEffect, useRef } from "react";

am4core.useTheme(am4themes_animated);
am4core.useTheme(am4themes_material);
am4core.useTheme(am4themes_dark);

function BarChartRace({ barChartRaceData, setYear, zoom }) {
  const chart = useRef(null);

  // if (!prefersDarkMode) {
  //   am4core.unuseTheme(am4themes_dark);
  // } else {
  //   am4core.useTheme(am4themes_dark);
  // }

  useLayoutEffect(() => {
    if (!barChartRaceData) {
      return () => {
        chart.current = false;
      };
    }

    const { allTopTwenty, firstYear, lastYear } = barChartRaceData;

    am4core.options.deferredDelay = 0;
    const x = am4core.create("chartdiv", am4charts.XYChart);
    x.responsive.enabled = true;
    x.padding(40, 40, 40, 40);
    // x.preloader.disabled = true;

    x.numberFormatter.bigNumberPrefixes = [
      // { number: 1e3, suffix: "K" },
      { number: 1e6, suffix: "M" },
      { number: 1e9, suffix: "B" },
    ];

    const label = x.plotContainer.createChild(am4core.Label);
    label.x = am4core.percent(97);
    label.y = am4core.percent(95);
    label.horizontalCenter = "right";
    label.verticalCenter = "middle";
    label.dx = -15;
    label.fontSize = 50;

    const playButton = x.plotContainer.createChild(am4core.PlayButton);
    playButton.x = am4core.percent(97);
    playButton.y = am4core.percent(95);
    playButton.dy = -2;
    playButton.verticalCenter = "middle";
    playButton.events.on("toggled", function (event) {
      if (event.target.isActive) {
        play();
      } else {
        stop();
      }
    });
    const stepDuration = 4000;

    const categoryAxis = x.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.dataFields.category = "channel";
    categoryAxis.renderer.minGridDistance = 1;
    categoryAxis.renderer.inversed = true;
    categoryAxis.renderer.maxColumns = 20;
    categoryAxis.renderer.grid.template.disabled = true;

    // Truncate Channel Names that are too long (looks nicer?)
    let channelLabel = categoryAxis.renderer.labels.template;
    channelLabel.truncate = true;
    channelLabel.maxWidth = 200;
    // channelLabel.tooltipText = "{channel}";

    const valueAxis = x.xAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    valueAxis.rangeChangeEasing = am4core.ease.linear;
    valueAxis.rangeChangeDuration = stepDuration;
    valueAxis.extraMax = 0.1;

    const series = x.series.push(new am4charts.ColumnSeries());
    series.dataFields.categoryY = "channel";
    series.dataFields.valueX = "count";
    series.tooltipText = "{valueX.value}";
    series.columns.template.strokeOpacity = 0;
    series.columns.template.column.cornerRadiusBottomRight = 5;
    series.columns.template.column.cornerRadiusTopRight = 5;
    series.columns.maxColumns = 1;
    series.interpolationDuration = stepDuration;
    series.interpolationEasing = am4core.ease.linear;

    // series.heatRules.push({
    //   target: series.columns.template,
    //   property: "fill",
    //   min: am4core.color("#F5DBCB"),
    //   max: am4core.color("#ED7B84"),
    //   dataField: "valueY",
    // });

    const labelBullet = series.bullets.push(new am4charts.LabelBullet());
    labelBullet.label.horizontalCenter = "right";
    labelBullet.label.text = "{values.valueX.workingValue.formatNumber('#.s')}";
    labelBullet.label.textAlign = "end";
    labelBullet.label.dx = -10;
    labelBullet.label.maxColumns = 1;
    labelBullet.label.truncate = false;
    labelBullet.label.hideOversized = false;

    x.zoomOutButton.disabled = true;

    // const colors = ["#242038", "#725AC1", "#8D86C9", "#CAC4CE", "#92BCEA"];

    // const colors = [am4core.color("#12c2e9"), am4core.color("#c471ed"), am4core.color("#f64f59")];

    const colors = [
      am4core.color("#12c2e9"),
      am4core.color("#9686EC"),
      am4core.color("#CD6BD2"),
      am4core.color("#7794EB"),
      am4core.color("#c471ed"),
      am4core.color("#f64f59"),
    ];
    // as by default columns of the same series are of the same color, we add adapter which takes colors from x.colors color set
    series.columns.template.adapter.add("fill", function (fill, target) {
      // console.log("coor", x.colors.getIndex(0));
      // return "#ffff00";

      const randIdx = Math.floor(Math.random() * colors.length);
      return colors[randIdx];
    });

    let year = firstYear;
    setYear(year);
    label.text = year.toString();

    let interval;

    function play() {
      categoryAxis.zoomToIndexes(0, zoom, true, true);
      x.invalidateRawData();
      // Wie lange jedes Zeit-Periode angezeigt wird
      interval = setInterval(function () {
        nextYear();
        // setYear(year);
      }, stepDuration);
      // nextYear();
    }

    function stop() {
      if (interval) {
        clearInterval(interval);
      }
    }

    function nextYear() {
      if (playButton.isActive !== false) {
        year++;
        setYear(year);
      }

      if (year > lastYear) {
        if (playButton.isActive !== false) {
          year = firstYear;
          setYear(firstYear);
        }
        // playButton.isActive = false; //triggers the toggled event, which calls stop when isActive is false
        return;
      }

      const newData = allData[year];

      let itemsWithNonZero = 0;

      for (let i = 0; i < x.data.length; i++) {
        x.data[i].count = newData[i].count;
        if (x.data[i].count > 0) {
          itemsWithNonZero = itemsWithNonZero + 1;
        }
      }

      // Wie schnell sich die Balken und die X-Achse animieren
      // if (year === firstYear) {
      //   series.interpolationDuration = stepDuration / 4;
      //   valueAxis.rangeChangeDuration = stepDuration / 4;
      // } else {
      series.interpolationDuration = stepDuration;
      valueAxis.rangeChangeDuration = stepDuration;
      // }

      // Redraw bars with the new values but without re-parsing the dataset
      x.invalidateRawData();
      label.text = year.toString();
      // Könnte man auch varibale machen mit Input vom User
      categoryAxis.zoomToIndexes(0, zoom);
    }

    categoryAxis.sortBySeries = series;

    const allData = allTopTwenty;
    x.data = JSON.parse(JSON.stringify(allData[year]));

    // Blakenbreite anpassen, je nach dem wie viele angezeigt werden
    // categoryAxis.zoom({ start: 0, end: 1 / x.data.length });
    series.events.on("inited", function () {
      playButton.isActive = true; // this starts interval
      // setTimeout(function () {}, 2000);
    });

    // Wie groß ein Balken ist
    const cellSize = 10;
    // Automatische höhen Berechnung vom Chart (je nachdem wie viele Balken)
    x.events.on("datavalidated", function (ev) {
      // Get objects of interest
      const x = ev.target;
      const categoryAxis = x.yAxes.getIndex(0);

      // Calculate how we need to adjust x height
      const adjustHeight = x.data.length * cellSize - categoryAxis.pixelHeight;

      // get current x height
      const targetHeight = x.pixelHeight + adjustHeight;

      // Set it on x's container
      x.svgContainer.htmlElement.style.height = targetHeight + "px";
    });
    x.logo.disabled = true;
    chart.current = x;

    return () => {
      clearInterval(interval);
      x.dispose();
    };
  }, [barChartRaceData, setYear, zoom]);

  return (
    <>
      <div id="chartdiv" style={{ maxWidth: "1000px", width: "100%" }}></div>
    </>
  );
}

export default BarChartRace;
